import { observable } from 'mobx';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { useEffect } from 'react';
import useMount from '@src/utils/hooks/use-mount';
import locales from './locales';

class ThirdSectionStore {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }
  // 页面是否展示
  @observable isActive = false;
  // 版本亮点列表  本地化
  versionHighlightsList = locales;

  // versionHighlightsList = [
  //   {
  //     title: 'PVE',
  //     info: 'AIRSHIP:CONSTANTINE',
  //     mapIcon: require('./images/thumbnail1.png'),
  //     characteristicImgs: require('./images/mecha1.png')
  //   },
  //   {
  //     title: '战利品',
  //     info: 'AIRSHIP:CONSTANTINE',
  //     mapIcon: require('./images/thumbnail1.png'),
  //     characteristicImgs: require('./images/mecha1.png')
  //   },
  //   {
  //     title: '撤离',
  //     info: 'AIRSHIP:CONSTANTINE',
  //     mapIcon: require('./images/thumbnail1.png'),
  //     characteristicImgs: require('./images/mecha1.png')
  //   },
  //   {
  //     title: '使命',
  //     info: 'AIRSHIP:CONSTANTINE',
  //     mapIcon: require('./images/thumbnail1.png'),
  //     characteristicImgs: require('./images/mecha1.png')
  //   },
  //   {
  //     title: '自定义武装',
  //     info: 'AIRSHIP:CONSTANTINE',
  //     mapIcon: require('./images/thumbnail1.png'),
  //     characteristicImgs: require('./images/mecha1.png')
  //   },
  //   {
  //     title: '超大战场',
  //     info: 'AIRSHIP:CONSTANTINE',
  //     mapIcon: require('./images/thumbnail1.png'),
  //     characteristicImgs: require('./images/mecha1.png')
  //   }
  // ];

  mapSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      spaceBetween: 0,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove: false
    }
  });
  tabSwiper = new BaseSwiperStore({
    swiperOptions: {
      slidesPerView: 5,
      centeredSlides: true,
      spaceBetween: 30,
      loop: true,
      loopedSlides: 5, // 显示的数量, 默认为3
      allowTouchMove: false,
      on: {
        click: event => {
          const { swiperSlideIndex } = event.target.dataset || {};
          this.mapSwiper.onChange(+swiperSlideIndex);
        }
      }
    }
  });

  /**
   * 切换
   * @param index
   */
  onClickChangeSwiper = index => {
    this.onClickChangeContentIndex(index);
  };
  /**
   * 点击切换内容轮播图的节点
   * @param index
   */
  onClickChangeContentIndex = index => {
    // console.log(index);
    this.mapSwiper.onChange(index);
  };

  use() {
    useMount(async () => {
      // this.mapSwiper.onSwiperAutoPlayChange(false);
    });
    useEffect(
      () => {
        this.tabSwiper.onChange(this.mapSwiper.activeIndex);
      },
      [this.mapSwiper.activeIndex]
    );
  }
}

export default ThirdSectionStore;
